<script lang="ts">
export default {
  name: "MainFobizzNavbarMyFobizzMenuHeader",
};
</script>

<script setup lang="ts">
type Props = {
  title: string;
};

defineProps<Props>();
</script>

<template>
  <div class="my-fobizz-offcanvas__menu__header">
    <p class="mb-0">
      {{ title }}
    </p>
    <slot></slot>
  </div>
</template>
